<script lang="ts">
  import './css/meetTheOwner.scss';
  import { getHref } from '../../helpers/sections-helper';
  import { BulletPoint } from '../../components/index';
  import type { MeetTheOwner } from '../types';

  export let properties: MeetTheOwner;

  $: ({ button, callouts, description, headline, image } = properties);
</script>

<section class="meet-the-owner">
  <div class="split" />
  <div class="wrapper">
    <div class="owner-content">
      <h2 class="h2">{@html headline?.value}</h2>
      <div class="image">
        <img loading="lazy" src={image?.value} alt="img-owner" />
      </div>
      <div class="owner-text">
        <p class="text">
          {@html description?.richText}
        </p>
      </div>
      {#if button?.label?.length}
        <div class="bottom-boxes">
          <a
            id="met-owner-book-now"
            class="primary-button open-form-js"
            href={getHref(button.link_type, button.link)}
            >{@html button.label}
          </a>
          <div class="small-text-box">
            {#each callouts.value as item}
              <div>
                <BulletPoint bulletIcon={callouts?.icon} />
                <p class="text-small">{@html item}</p>
              </div>
            {/each}
          </div>
        </div>
      {/if}
    </div>
  </div>
</section>
